import styled from 'styled-components';
import { device } from '../../../utils/styled-component-mixins';

const FilterContainerStyled = styled.div`
  .filters-container {
    position: relative;

    @media ${device.desktop} {
      padding-right: 4rem;
    }
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;

    legend {
      color: var(--slate);
      font-size: 1.2rem;
      font-weight: 400;
      letter-spacing: 0.07rem;
      line-height: 1.6rem;
      padding: 2.5rem 0rem 2.8rem 1.6rem;
    }
  }

  .mobile-controls {
    background-color: var(--white);
    bottom: 0;
    box-shadow: 0px -40px 40px rgba(51, 51, 51, 0.1);
    display: flex;
    grid-gap: 0.8rem;
    padding: 1.6rem 1.6rem 2.4rem 1.6rem;
    position: absolute;
    width: 100%;

    div[class^='WidgetSpacingWrapper'] {
      flex: 1 1 auto;

      &:first-child {
        span {
          text-transform: uppercase;
        }
      }

      .btn-wrapper {
        height: 100%;
      }

      button {
        justify-content: center;
        width: 100%;
      }
    }
  }

  .filter-group {
    display: flex;
    width: 100%;

    &:last-child {
      label {
        border-bottom: 2px solid var(--grey);
      }
    }

    &.no-results {
      label,
      span {
        color: var(--button-disabled-text);
      }

      label {
        cursor: auto;
      }

      input {
        &:hover:not(:checked) ~ label,
        &:focus:not(:checked) ~ label {
          background-color: var(--white);
        }
      }
    }

    input {
      cursor: pointer;
      height: 0;
      opacity: 0;
      position: absolute;
      width: 0;

      &:checked ~ label {
        background-color: var(--slate);
        border-color: transparent;
        color: var(--white);
      }

      &:hover:not(:checked) ~ label,
      &:focus:not(:checked) ~ label {
        background-color: var(--light-grey-2);
      }
    }

    label {
      border-top: 2px solid var(--grey);
      cursor: pointer;
      display: flex;
      font-size: 1.8rem;
      font-weight: 800;
      justify-content: space-between;
      line-height: 2.4rem;
      padding: 2.4rem 1.6rem;
      width: 100%;

      @media ${device.desktop} {
        font-size: 2.2rem;
        line-height: 3.2rem;
      }

      span {
        font-size: 1.6rem;
        font-weight: 700;
        margin-left: 1.5rem;
      }
    }
  }
`;

export default FilterContainerStyled;
